import styled from "@emotion/styled";
import { FormControl, InputLabel, OutlinedInput } from "@mui/material";

export const CustomFormControl = styled(FormControl)`
  background-color: ${({ theme }) => theme.palette.primary.light};
  width: 100%;
`;

export const CustomLabel = styled(InputLabel)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(17)};
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
`;

export const CustomInput = styled(OutlinedInput)`
  border-radius: 0;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(17)};
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: capitalize;
`;
